import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveEntry20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMoveEntry20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M7.54 8.493a.75.75 0 0 1-.75.75H1.94a.75.75 0 0 1 0-1.5h4.85a.75.75 0 0 1 .75.75M7.404 11.5a.75.75 0 0 1-.75.75H3.358a.75.75 0 0 1 0-1.5h3.297a.75.75 0 0 1 .75.75m10.654-1.413a4.626 4.626 0 1 1-9.252 0 4.626 4.626 0 0 1 9.252 0m-1.5 0a3.126 3.126 0 1 0-6.252 0 3.126 3.126 0 0 0 6.252 0"
            />
        </svg>
    );
}
export default memo(IconMoveEntry20);
